function SwitchWhyWe(container){
	$(container).click(function(){
		var href = container.attr('href');

		$('href').show();

		var first = $('href').find('li:first');

		first.addClass('active');
		$('sub_href').show();

		if ( !container.parent('li').hasClass('active') ){
			$('.why-we-block').hide();
			$('.j-switch-why-we-blocks').parent('li').removeClass('active');
			container.parent('li').addClass('active');
			$(href).fadeIn();
			return false;
		}
		return false;
	});

}

if (typeof define === "function" && define.amd) {
	define('Controls/SwitchWhyWe',[], function() {
		return SwitchWhyWe;
	});
};
